var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStyleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 1.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.096 5.59h11.061v11.061H7.096zM7.096 21.338h11.061v11.061H7.096zM22.844 5.59h11.061v11.061H22.844z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.61 10.752 2.073 2.212 3.457-3.687M9.861 26.5l2.074 2.212 3.457-3.687M27.956 25.711 25.68 21.77a1.677 1.677 0 1 0-2.904 1.677l3.702 6.412"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 27.486c-.706.681-1.296 2.148-.297 3.879s2.905 3.13 3.733 3.612l6.798-3.925c.218-.812.353-2.697-1.065-5.153-1.328-2.3-5.194-1.281-6.43-.568l-.395-.682"
}))));
export default SvgIconStyleCheck;